const seyorText = (key, values) => window.SeyorUI.t(key, values);
const toggle = document.querySelector('.menu-toggle');
const panel = document.querySelector('.menu-panel');
const shade = document.querySelector('.menu-shade');
const close = document.querySelector('.menu-close');

function setMenu(open) {
  if (!panel) return;
  panel.classList.toggle('open', open);
  shade?.classList.toggle('open', open);
  panel.setAttribute('aria-hidden', String(!open));
  panel.toggleAttribute('inert', !open);
  toggle?.setAttribute('aria-expanded', String(open));
  document.body.classList.toggle('menu-open', open);
}

toggle?.addEventListener('click', () => setMenu(true));
close?.addEventListener('click', () => setMenu(false));
shade?.addEventListener('click', () => setMenu(false));
document.addEventListener('keydown', event => {
  if (event.key === 'Escape') setMenu(false);
});

document.querySelectorAll('[data-product-section]').forEach(section => {
  const mainImage = section.querySelector('.product-main-image');
  const productMedia = section.querySelector('.product-media');
  const thumbnails = [...section.querySelectorAll('[data-product-image]')];
  let activeImageIndex = Math.max(0, thumbnails.findIndex(button => button.classList.contains('active')));
  const imageUrl = button => window.matchMedia('(max-width: 720px)').matches
    ? button.dataset.productImageMobile || button.dataset.productImage
    : button.dataset.productImageDesktop || button.dataset.productImage;
  const preloadImage = button => {
    if (!button) return;
    const preload = new Image();
    preload.decoding = 'async';
    preload.src = imageUrl(button);
  };
  const showImage = requestedIndex => {
    if (!mainImage || thumbnails.length === 0) return;
    activeImageIndex = (requestedIndex + thumbnails.length) % thumbnails.length;
    const button = thumbnails[activeImageIndex];
    const nextUrl = imageUrl(button);
    mainImage.classList.add('is-changing');
    mainImage.src = nextUrl;
    mainImage.removeAttribute('srcset');
    mainImage.alt = button.dataset.productAlt || mainImage.alt;
    mainImage.decode?.().catch(() => {}).finally(() => mainImage.classList.remove('is-changing'));
    thumbnails.forEach(item => {
      item.classList.toggle('active', item === button);
      if (item === button) item.setAttribute('aria-current', 'true'); else item.removeAttribute('aria-current');
    });
    button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    preloadImage(thumbnails[(activeImageIndex + 1) % thumbnails.length]);
  };
  thumbnails.forEach((button, index) => {
    button.addEventListener('click', () => showImage(index));
    button.addEventListener('pointerenter', () => preloadImage(button), { once: true });
    button.addEventListener('focus', () => preloadImage(button), { once: true });
    button.addEventListener('touchstart', () => preloadImage(button), { passive: true, once: true });
  });
  if (thumbnails.length > 1 && productMedia) {
    let touchStartX = 0;
    let touchStartY = 0;
    productMedia.addEventListener('touchstart', event => {
      touchStartX = event.changedTouches[0].clientX;
      touchStartY = event.changedTouches[0].clientY;
    }, { passive: true });
    productMedia.addEventListener('touchend', event => {
      const deltaX = event.changedTouches[0].clientX - touchStartX;
      const deltaY = event.changedTouches[0].clientY - touchStartY;
      if (Math.abs(deltaX) > 45 && Math.abs(deltaX) > Math.abs(deltaY)) showImage(activeImageIndex + (deltaX < 0 ? 1 : -1));
    }, { passive: true });
    productMedia.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight') { event.preventDefault(); showImage(activeImageIndex + 1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); showImage(activeImageIndex - 1); }
    });
    preloadImage(thumbnails[1]);
  }
  const quantity = section.querySelector('.product-quantity input');
  const stockLimitMessage = section.querySelector('[data-stock-limit-message]');
  const setInventoryLimit = limitValue => {
    if (!quantity) return;
    const limit = Number.parseInt(limitValue, 10);
    if (Number.isFinite(limit)) quantity.max = String(Math.max(0, limit));
    else quantity.removeAttribute('max');
    if (quantity.max && Number(quantity.value) > Number(quantity.max)) quantity.value = quantity.max;
    if (stockLimitMessage) stockLimitMessage.hidden = true;
  };
  const showInventoryLimit = () => {
    if (!stockLimitMessage || !quantity?.max) return;
    stockLimitMessage.textContent = seyorText('general.only_available', { quantity: quantity.max });
    stockLimitMessage.hidden = false;
  };
  section.querySelectorAll('[data-qty-change]').forEach(button => {
    button.addEventListener('click', () => {
      if (!quantity) return;
      const requested = Math.max(1, (Number.parseInt(quantity.value, 10) || 1) + Number(button.dataset.qtyChange));
      const maximum = quantity.max ? Number.parseInt(quantity.max, 10) : Number.POSITIVE_INFINITY;
      quantity.value = String(Math.min(requested, maximum));
      if (requested > maximum) showInventoryLimit(); else if (stockLimitMessage) stockLimitMessage.hidden = true;
    });
  });
  quantity?.addEventListener('change', () => {
    const maximum = quantity.max ? Number.parseInt(quantity.max, 10) : Number.POSITIVE_INFINITY;
    const requested = Math.max(1, Number.parseInt(quantity.value, 10) || 1);
    quantity.value = String(Math.min(requested, maximum));
    if (requested > maximum) showInventoryLimit(); else if (stockLimitMessage) stockLimitMessage.hidden = true;
  });
  const variantOptions = [...section.querySelectorAll('[data-variant-option]')];
  const currentPrice = section.querySelector('[data-current-price]');
  const comparePrice = section.querySelector('[data-compare-price]');
  const saleBadge = section.querySelector('[data-sale-badge]');
  const addButton = section.querySelector('[data-add-to-cart]');
  const stockStatus = section.querySelector('[data-stock-status]');
  const updateVariant = option => {
    if (currentPrice && option?.dataset.price) currentPrice.textContent = option.dataset.price;
    const compareAtPrice = option?.dataset.compareAtPrice || '';
    if (comparePrice) {
      comparePrice.textContent = compareAtPrice;
      comparePrice.hidden = !compareAtPrice;
    }
    if (saleBadge) saleBadge.hidden = !compareAtPrice;
    const available = option?.dataset.available === 'true';
    setInventoryLimit(option?.dataset.inventoryLimit);
    if (addButton) {
      addButton.disabled = !available;
      addButton.textContent = seyorText(available ? 'cart.add' : 'general.sold_out');
    }
    if (stockStatus) {
      stockStatus.dataset.available = String(available);
      stockStatus.textContent = seyorText(available ? 'product.in_stock' : 'general.sold_out');
      stockStatus.classList.toggle('sold-out', !available);
    }
  };
  variantOptions.forEach(option => option.addEventListener('change', () => updateVariant(option)));
});

const filters = [...document.querySelectorAll('.shop-filter[data-filter]')];
const productCards = [...document.querySelectorAll('[data-product-category]')];
const filteredEmpty = document.querySelector('.filtered-empty');
const braceletTabs = document.querySelector('.bracelet-tabs');
const braceletFilters = [...document.querySelectorAll('.bracelet-filter[data-filter]')];

function showCategory(category) {
  if (!filters.length) return;
  const braceletTypes = ['leather', 'stone', 'steel'];
  const selected = category === 'necklaces' ? 'necklaces' : (braceletTypes.includes(category) ? category : 'bracelets');
  let visible = 0;

  productCards.forEach(card => {
    const show = selected === 'necklaces'
      ? card.dataset.productCategory === 'necklaces'
      : card.dataset.productCategory === 'bracelets' && (selected === 'bracelets' || card.dataset.productMaterial === selected);
    card.hidden = !show;
    if (show) visible += 1;
  });

  filters.forEach(filter => {
    const active = selected === 'necklaces' ? filter.dataset.filter === 'necklaces' : filter.dataset.filter === 'bracelets';
    filter.classList.toggle('active', active);
    filter.setAttribute('aria-current', active ? 'true' : 'false');
  });

  if (braceletTabs) braceletTabs.hidden = selected === 'necklaces';
  braceletFilters.forEach(filter => {
    const active = filter.dataset.filter === selected;
    filter.classList.toggle('active', active);
    filter.setAttribute('aria-current', active ? 'true' : 'false');
  });

  if (filteredEmpty) filteredEmpty.hidden = visible !== 0 || productCards.length === 0;
}

if (filters.length) {
  const firstCategory = location.hash.slice(1);
  showCategory(firstCategory);
  window.addEventListener('hashchange', () => showCategory(location.hash.slice(1)));
}

document.querySelectorAll('.cart-line').forEach((line, index) => {
  const input = line.querySelector('input[name="updates[]"]');
  const form = line.closest('form');
  const stockMessage = line.querySelector('[data-cart-stock-message]');
  if (!input || !form) return;

  input.min = '1';
  const inventoryLimit = Number.parseInt(line.dataset.inventoryLimit, 10);
  if (Number.isFinite(inventoryLimit)) input.max = String(inventoryLimit);
  const controls = document.createElement('div');
  controls.className = 'cart-quantity-controls';

  const minus = document.createElement('button');
  minus.type = 'button';
  minus.className = 'cart-quantity-button';
  minus.textContent = '−';
  minus.setAttribute('aria-label', seyorText('general.decrease_quantity'));
  minus.dataset.i18nAria = 'general.decrease_quantity';

  const plus = document.createElement('button');
  plus.type = 'button';
  plus.className = 'cart-quantity-button';
  plus.textContent = '+';
  plus.setAttribute('aria-label', seyorText('general.increase_quantity'));
  plus.dataset.i18nAria = 'general.increase_quantity';

  const remove = document.createElement('a');
  remove.className = 'cart-remove';
  remove.textContent = seyorText('cart.remove');
  remove.dataset.i18n = 'cart.remove';
  remove.setAttribute('aria-label', seyorText('cart.remove_item'));
  remove.dataset.i18nAria = 'cart.remove_item';
  remove.href = `${window.SeyorConfig.cartChangeUrl}?line=${index + 1}&quantity=0`;

  const updateCart = () => {
    const updateButton = form.querySelector('button[name="update"]');
    if (updateButton) form.requestSubmit(updateButton);
    else form.requestSubmit();
  };

  const setCartQuantity = requested => {
    const maximum = input.max ? Number.parseInt(input.max, 10) : Number.POSITIVE_INFINITY;
    const nextQuantity = Math.min(Math.max(1, requested), maximum);
    input.value = String(nextQuantity);
    if (stockMessage) {
      stockMessage.textContent = requested > maximum ? seyorText('general.only_available', { quantity: maximum }) : '';
      stockMessage.hidden = requested <= maximum;
    }
    return requested <= maximum;
  };

  minus.addEventListener('click', () => {
    const current = Number.parseInt(input.value, 10) || 1;
    if (current <= 1) return;
    setCartQuantity(current - 1);
    updateCart();
  });

  plus.addEventListener('click', () => {
    const valid = setCartQuantity((Number.parseInt(input.value, 10) || 1) + 1);
    if (valid) updateCart();
  });

  input.addEventListener('change', () => {
    setCartQuantity(Number.parseInt(input.value, 10) || 1);
  });

  input.parentNode.insertBefore(controls, input);
  controls.append(minus, input, plus);
  controls.insertAdjacentElement('afterend', remove);
});
